export default "__VITE_ASSET__6980233b__"